import { Switch } from "@chakra-ui/react";
import { useController } from "react-hook-form";
import ErrorLabel from "./ErrorLabel";

export default function SwitchControl({ control, name, label, isRequired = false, rules, isMulti = false, ...rest }) {
	const {
		field: { value , onChange, ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label ? label : "Input"} is required`, ...rules },
	});
    return (
        <>
            <Switch 
                value={value}
                colorScheme="brand" 
                onChange={onChange}
                {...field} {...rest}
                isChecked={value}
            />  
 			<ErrorLabel>{error?.message}</ErrorLabel>
        </>
    )
}
